<template>
  <div>
    <div v-if="value === 0">Diajukan</div>
    <DxButton
      v-else-if="value === 1"
      text="Disetujui"
      type="success"
      width="auto"
      height="18px"
      icon="check"
    />
    <DxButton
      v-else-if="value === 2"
      text="Ditolak"
      type="danger"
      width="auto"
      height="18px"
      icon="close"
    />
  </div>
</template>

<script>
import DxButton from "devextreme-vue/button";
export default {
  components: {
    DxButton,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {},
  methods: {},
};
</script>
